export default __webpack_public_path__ + "static/media/sbo-icon-active.668d37c1.svg";